import React, { useState, useEffect, useMemo } from 'react'

import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

import { BsDashCircle, BsPlusCircle } from "react-icons/bs";

import { useTranslation } from "react-i18next";

import { useConfig } from '../../contexts/ConfigContext';

import { useProduct } from '../../contexts/ProductContext';

import { useCart } from '../../contexts/CartContext';

import { useTheme } from '../../contexts/ThemeContext';

import { Button, OutlineBtn } from '../Shared/Buttons'

import { ProductsCarousel } from '../Shared/Carousel'

import { ProductPriceDisplay } from '../Shared/ProductPrice'

import {

  isProductUnavailable,

  hasVariantOptions,

  areRequiredOptionsSelected,

  getDetailPriceInfo,

  getSelectedVariantIds,

  showNoteField,

  matchesVariantCombination,

  getOptionId,

  getVariantId,

  getVariantInventoryQty,

  getSelectedAvailableQty,

} from '../../utils/productPricing'



import {

  ModalContainer,

  ModalDialog,

  ModalFooter

} from '../Shared/SideModal'



import {

  ProdModalHeader,

  CloseModal,

  ProdMain,

  ProdDetail,

  ProdTitle,

  ProdDes,

  ProdPrice,

  ProdToCart,

  OptionGroup,

  OptionLabel,

  OptionVariants,

  NoteField,

  NoteLabel,

  NoteTextarea,

  ValidationMessage,

} from './styles';



export const ProductDetailView = (props) => {



  const { prodCloseHandleClick, prodId, vendorId } = props

  const currentLng = localStorage.getItem('i18nextLng');

  const [configState] = useConfig()

  const [products] = useProduct();

  const [cart, { addMultiProd, currentVendorId }] = useCart();

  const activeVendorId = vendorId || currentVendorId;

  const [theme] = useTheme()

  const { t } = useTranslation();

  const [count, setCount] = useState(1);

  const [selections, setSelections] = useState({});

  const [note, setNote] = useState('');

  const [validationError, setValidationError] = useState('');



  const prod = products.find(obj => obj.id === prodId)

  const unavailable = isProductUnavailable(prod)

  const priceInfo = useMemo(() => getDetailPriceInfo(prod, selections), [prod, selections])

  const sellingPrice = priceInfo.sellingPrice || 0

  const variantIds = getSelectedVariantIds(selections)

  const requiredSelected = areRequiredOptionsSelected(prod, selections)

  const availableQty = useMemo(
    () => getSelectedAvailableQty(prod, selections),
    [prod, selections]
  )

  const maxCount = availableQty != null ? availableQty : null

  const canAddPrice = priceInfo.canAdd && sellingPrice > 0 && (maxCount == null || maxCount > 0)

  const deCount = () => {
    if (count > 1) setCount(prev => prev - 1);
  }

  const inCount = () => {
    if (maxCount != null && count >= maxCount) return
    setCount(prev => prev + 1);
  }

  const handleVariantSelect = (optionId, variantId) => {
    setSelections(prev => {
      const nextSelections = { ...prev, [optionId]: variantId }
      const nextQty = getSelectedAvailableQty(prod, nextSelections)
      if (nextQty != null) {
        setCount(nextQty > 0 ? 1 : 0)
      }
      return nextSelections
    })
    setValidationError('')
  }



  const AddToOrder = () => {

    if (unavailable) return



    if (hasVariantOptions(prod) && !requiredSelected) {

      setValidationError(t('Please select all required options'))

      return

    }



    if (hasVariantOptions(prod) && !canAddPrice) {
      if (availableQty === 0) {
        setValidationError(t('Not available'))
      } else {
        setValidationError(t('Please select all required options'))
      }
      return
    }



    const addOptions = { vendorId: activeVendorId }

    const trimmedNote = note.trim()

    if (trimmedNote) addOptions.note = trimmedNote

    if (variantIds.length) addOptions.variant_combination = variantIds



    addMultiProd(prodId, count, sellingPrice, addOptions);

    prodCloseHandleClick();

  }



  useEffect(() => {

    const matchedProd = cart.find(

      obj => obj.prodId === prodId && matchesVariantCombination(obj.variant_combination, variantIds)

    );

    const base = matchedProd ? matchedProd.count : 1

    if (maxCount == null) {
      setCount(Math.max(1, base))
    } else if (maxCount <= 0) {
      setCount(0)
    } else {
      setCount(Math.min(Math.max(1, base), maxCount))
    }

  }, [cart, prodId, variantIds.join(','), maxCount])



  useEffect(() => {

    setSelections({})

    setNote('')

    setValidationError('')

    setCount(1)

  }, [prodId])



  if (!prod) return null



  const buttonDisabled = unavailable || count === 0 || (hasVariantOptions(prod) && (!requiredSelected || !canAddPrice))

  const canIncrement = !unavailable && (maxCount == null || count < maxCount)

  const buttonColor = !unavailable && !buttonDisabled ? 'primary' : 'gray'



  return (

    <ModalContainer>

      <ModalDialog>

        <ProdModalHeader>

          <CloseModal onClick={prodCloseHandleClick}>

            {currentLng === 'en'

              ? <FiArrowLeft size="20" color="white" />

              : <FiArrowRight size="20" color="white" />

            }

          </CloseModal>

        </ProdModalHeader>

        <ProdMain>

          <ProductsCarousel images={prod.images} alt={prod.name}></ProductsCarousel>

          <ProdDetail>

            <ProdTitle>

              {currentLng === 'en' ? prod.name_en : prod.name_ar}

            </ProdTitle>

            <ProdDes>

              {currentLng === 'en' ? prod.description_en : prod.description_ar}

            </ProdDes>

          </ProdDetail>



          {hasVariantOptions(prod) && prod.options.map(option => {

            const optionId = getOptionId(option)

            return (

            <OptionGroup key={optionId}>

              <OptionLabel>

                {currentLng === 'en' ? option.name_en : option.name_ar}

                {option.required == 1 || option.required === true || option.required === '1'

                  ? ` (${t('Required')})`

                  : ` (${t('Optional')})`}

              </OptionLabel>

              <OptionVariants>

                {(option.variants || []).map(variant => {

                  const variantId = getVariantId(variant)

                  const variantStock = getVariantInventoryQty(prod.inventory, [variantId])

                  const variantOutOfStock = variantStock === 0

                  return (

                  <OutlineBtn

                    key={variantId}

                    color={selections[optionId] === variantId ? theme.colors?.primaryButtCol : '#888'}

                    onClick={() => !variantOutOfStock && handleVariantSelect(optionId, variantId)}

                    disabled={unavailable || variantOutOfStock}

                  >

                    {currentLng === 'en' ? variant.name_en : variant.name_ar}

                    {variantOutOfStock && ` (${t('Not available')})`}

                  </OutlineBtn>

                  )

                })}

              </OptionVariants>

            </OptionGroup>

            )

          })}



          {showNoteField(prod) && (

            <NoteField>

              <NoteLabel>{t('Add Note')}</NoteLabel>

              <NoteTextarea

                value={note}

                onChange={(e) => setNote(e.target.value)}

                placeholder={t('Add Note')}

                disabled={unavailable}

              />

            </NoteField>

          )}



          <ProdPrice>

            <div>{t('Price')}</div>

            <ProductPriceDisplay priceInfo={priceInfo} unavailable={unavailable} />

          </ProdPrice>



          <ProdToCart unavailable={unavailable}>

            <BsDashCircle

              size={25}

              color={!unavailable ? theme.colors?.primaryButtCol : theme.colors?.primaryDisabledCol}

              onClick={() => !unavailable && deCount()}

            />

            {count}

            <BsPlusCircle

              size={25}

              color={canIncrement ? theme.colors?.primaryButtCol : theme.colors?.primaryDisabledCol}

              onClick={() => canIncrement && inCount()}

            />

          </ProdToCart>

          {validationError && (

            <ValidationMessage>{validationError}</ValidationMessage>

          )}

        </ProdMain>

        <ModalFooter>

          <Button

            color={buttonColor}

            width="100%" uppercase={true}

            onClick={AddToOrder}

            disabled={buttonDisabled}

          >

            {unavailable

              ? t('Not available')

              : t('Add to order')}

            {!unavailable && canAddPrice && ` ${count * sellingPrice} ${t(configState?.configs?.currency)}`}

          </Button>

        </ModalFooter>

      </ModalDialog>

    </ModalContainer>

  )

}

